import {
  INIT_LOGIN
} from './mutations-type.js'

export default {
  [INIT_LOGIN] (state, data) {
    state.initLogin = data
  }
}
